import React, { Component } from "react";
import {
  Spin,
  Modal,
  Empty,
  Popconfirm,
  Button,
  Checkbox,
  InputNumber,
  Select,
  Input,
  Pagination,
} from "antd";

import { withDomains, RESTExecutor } from "../../lib/domain";
import ErrorWrapper from "../../lib/error_wrapper";
import moment from "moment";

import { Link } from "react-router-dom";
import ModalTransactionDetail from "../../components/modal_transaction_detail";
import { BasicHeader } from "../../components/basic_header";
import { CustomButton, TransparentButton } from "../../components/basic_items";
import { StorageOutlined } from "@material-ui/icons";
import GroupedUnreconciledCard from "../../components/grouped_unreconciled_card";
import { COLORS } from "../theme";
import {
  defaultDateFormat,
  formatMoney,
  showErrorInNotification,
} from "../../lib/util";
import CustomDateRangePicker from "../../components/custom_date_range";

export const OURS_KEY = "ours";
export const THEIRS_KEY = "theirs";

class GroupedUnreconciledData extends Component {
  constructor(props) {
    super(props);
    this.reconciler_id = props.match.params.reconciler_id;
    this.source_id = this.props.match.params.source_id;
    this.group_id = this.props.match.params.group_id;

    this.state = {
      mode: "RECONCILE", //support batch and reconcile
      loading: true,
      loadingAll: false,
      source_obj: {},
      expanded_items: [],
      data: { rows: [] },
      rowMeta: {},
      view_transaction_id: null,
      selected_items: {},
      reconcileLoading: null,
      reconcileAllLoading: false,
      isEqual: false,
      advanceFilter: false,
      filter_query: {
        per_page: 30,
        page: 1,
      },
      our_services: [],
      their_services: [],
    };

    this.detail_source = RESTExecutor.detail()
      .forId(this.source_id)
      .config({
        label: "groupsourcedetailbasics",
      })
      .callbacks(
        (success) => {
          // make first id default tab if not done previously
          this.setState({
            source_obj: success.result,
            loading: false,
          });
          this.list_grouped_unreconciled_data.execute();
        },
        (error) => {}
      )
      .connect(props.domains.usergroups);

    this.get_reconcilers = RESTExecutor.detail()
      .config({
        label: "detail_reconcilers",
      })
      .forId(this.reconciler_id)
      .callbacks(
        (success) => {
          const result = success.result ?? {};
          const reference = result.__references__ ?? {};
          const ourDatatype = reference.our_data_type_id ?? {};
          const theirDatatype = reference.their_data_type_id ?? {};
          this.getServicesForDatatype(theirDatatype.id, "their_services");
          this.getServicesForDatatype(ourDatatype.id, "our_services");

          this.detail_source.forId(this.source_id).execute();
        },
        (error) => {
          this.setState({ loading: false });
        }
      )
      .connect(props.domains.reconciliation);

    this.get_reconcilers.execute();

    this.list_grouped_unreconciled_data = RESTExecutor.list()
      .config({
        label: "grouped_unreconciled",
        params: {
          source_id: this.source_id,
          reconciler_id: this.reconciler_id,
          ...this.state.filter_query,
        },
      })
      .withTimeout(10 * 1000 * 60)
      .callbacks(
        (success) => {
          this.setState({
            loading: false,
            error: false,
            pageLoading: false,
            data: success.result,
            rowMeta: success.meta ?? {},
          });
        },
        (error) => {
          this.setState({
            error: true,
            loading: false,
          });
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.reconciliation);


    this.downloadMatchedDataExecurot=RESTExecutor.detail().config({
      label:"grouped_unreconciled_download",
      params:{
        //source_id and reconciler_id will be filled while executing
      }
    })
    .callbacks((success)=>{
      window.open(success.result.url, '_blank');
    },err=>{
      showErrorInNotification(err)
    })
    .connect(props.domains.reconciliation);

    this.list_services_fordatatype = RESTExecutor.list()
      .config({
        label: "datatype_services",
        params: {
          pagination: false,
        },
      })
      .callbacks(
        () => {
          console.log("listed for manual");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.allData);
    let reconciler = this.source_id || {};

    this.reconcile_manually = RESTExecutor.post()
      .config({
        label: "reconcile_manually",
      })
      .connect(props.domains.reconciliation);

    this.reconcile_all_manually = RESTExecutor.post()
      .config({
        label: "reconcile_all_manually",
      })
      .connect(props.domains.reconciliation);

    console.log("Window val", window.slider_main);
    setTimeout(() => {
      if (window.slider_main) {
        try {
          window.slider_main.changeSliderState(true);
        } catch (e) {
          console.log("Failed to close slider");
        }
      }
    }, 1000);
  }

  showTransactionModal = (id) => {
    this.setState({
      view_transaction_id: id,
    });
  };

  getServicesForDatatype = (datatypeID, stateKey) => {
    this.list_services_fordatatype
      .forId(datatypeID)
      .callbacks((success) => {
        let results = success.result ?? {};
        this.setState({
          [stateKey]: results.rows ?? [],
        });
      })
      .execute();
  };

  removeItem = (dataIndex) => {
    const selectedItems = this.state.selected_items;
    const selectedItem = selectedItems[dataIndex];
    const { ours, theirs } = selectedItem;
    let newData = this.state.data;
    let newOurs = newData.rows?.[dataIndex]?.ours;
    let newTheirs = newData.rows?.[dataIndex]?.theirs;
    let b = newOurs?.forEach((i, index) => {
      if (i.id === ours) newOurs.splice(index, 1);
    });
    let a = newTheirs?.forEach((i, index) => {
      if (i.id === theirs) newTheirs.splice(index, 1);
    });
    if (newOurs.length === 0 || newTheirs.length === 0) {
      newData.rows.splice(dataIndex, 1);
      this.expandItems(dataIndex);
    }
    delete selectedItems[dataIndex];
    this.setState({
      data: newData,
      selected_items: selectedItems,
    });
  };

  removeCardItem = (dataIndex) => {
    let newData = this.state.data;
    newData.rows.splice(dataIndex, 1);
    const selectedItems = this.state.selected_items;
    delete selectedItems[dataIndex];
    this.expandItems(dataIndex);
    this.setState({
      data: newData,
      selected_items: selectedItems,
    });
  };

  removeWholeData = () => {
    this.setState({
      data: { rows: [] },
    });
  };

  onReconcile = (dataIndex) => {
    this.setState({
      reconcileLoading: `loading${dataIndex}`,
    });
    this.reconcile_manually
      .forId(this.reconciler_id)
      .callbacks(
        (success) => {
          this.removeItem(dataIndex);
          this.setState({
            reconcileLoading: null,
          });
        },
        (error) => {
          showErrorInNotification(error);
          this.setState({
            reconcileLoading: null,
          });
        }
      )
      .execute({
        our_id: this.state.selected_items[dataIndex].ours,
        their_id: this.state.selected_items[dataIndex].theirs,
        source_id: this.source_id,
      });
  };

  onReconcileAll = (dataIndex) => {
    this.setState({
      reconcileAllLoading: `loading${dataIndex}`,
    });
    const our_txns = this.state.data.rows[dataIndex].ours.map((i) => i.id);
    const their_txns = this.state.data.rows[dataIndex].theirs.map((i) => i.id);
    this.reconcile_all_manually
      .config({
        params: {
          reconciler_id: this.reconciler_id,
          source_id: this.source_id,
        },
      })
      .callbacks(
        (success) => {
          this.removeCardItem(dataIndex);
          this.setState({
            reconcileAllLoading: null,
          });
        },
        (error) => {
          showErrorInNotification(error);
          this.setState({
            reconcileAllLoading: null,
          });
        }
      )
      .execute({
        our_txns,
        their_txns,
      });
  };

  onReconcileWholeData = () => {
    this.setState({
      loadingAll: true,
    });
    let our_txns = [];
    let their_txns = [];
    this.state.data.rows.forEach((row) => {
      const less_data = Math.min(row.ours.length, row.theirs.length);
      for (let i = 0; i < less_data; i++) {
        our_txns.push(row.ours[i].id);
        their_txns.push(row.theirs[i].id);
      }
    });
    this.reconcile_all_manually
      .config({
        params: {
          reconciler_id: this.reconciler_id,
          source_id: this.source_id,
        },
      })
      .callbacks(
        (success) => {
          this.removeWholeData();
          this.setState({
            loadingAll: null,
          });
        },
        (error) => {
          showErrorInNotification(error);
          this.setState({
            loadingAll: null,
          });
        }
      )
      .execute({
        our_txns,
        their_txns,
      });
  };

  isEqualFunction = () => {
    return (
      <div style={{ marginRight: "24px", alignSelf: "center" }}>
        <Checkbox
          defaultChecked={this.state.isEqual}
          onChange={(e) => {
            console.log(this.state.isEqual);
            this.setState({ isEqual: e.target.checked });
            let params = !this.state.isEqual
              ? {
                  source_id: this.source_id,
                  reconciler_id: this.reconciler_id,
                  equal: e.target.checked,
                  ...this.state.filter_query,
                }
              : {
                  source_id: this.source_id,
                  reconciler_id: this.reconciler_id,
                  ...this.state.filter_query,
                };

            this.list_grouped_unreconciled_data
              .config({
                params: params,
              })
              .execute();
          }}
        >
          Show Items with Equal Counts of Txns Only
        </Checkbox>
      </div>
    );
  };

  setSelectedItem = (dataIndex, isOurs, itemId) => {
    const newSelectedData = this.state.selected_items;
    newSelectedData[dataIndex] = newSelectedData[dataIndex] ?? {};
    const item = newSelectedData[dataIndex][isOurs ? "ours" : "theirs"];
    newSelectedData[dataIndex][isOurs ? "ours" : "theirs"] =
      item === itemId ? null : itemId;
    this.setState({
      selected_items: newSelectedData,
    });
  };

  expandItems = (id) => {
    const expandedItems = this.state.expanded_items;
    if (expandedItems.includes(id)) {
      expandedItems.splice(expandedItems.indexOf(id), 1);
    } else {
      if (expandedItems.length >= 1) {
        expandedItems.shift();
      }
      expandedItems.push(id);
    }
    this.setState({
      expanded_items: expandedItems,
    });
  };
  getParams = () => {
    let params = JSON.parse(JSON.stringify(this.state.filter_query));

    return params;
  };
  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };
  render() {
    const {
      loading,
      loadingAll,
      mode,
      source_obj,
      filter_query,
      expanded_items,
    } = this.state;
    if (loading) {
      return (
        <center>
          <Spin />
        </center>
      );
    }

    let get_reconcilers_resp = this.get_reconcilers.response();
    let get_reconcilers_data = get_reconcilers_resp.result || {};
    let detail_source_resp = this.detail_source.response();
    let list_grouped_unreconciled_resp =
      this.list_grouped_unreconciled_data.response();
    let reference = get_reconcilers_data.__references__ || {};
    let list_service_fordatatype_resp =
      this.list_services_fordatatype.response();
    let service_list =
      (list_service_fordatatype_resp.result &&
        list_service_fordatatype_resp.result.rows) ||
      [];
    let rowMeta = this.state.rowMeta || {};
    // let filter_query = [];
    console.log({ filter_query });
    console.log(this.state.data.rows.length, "length");

    return (
      <ErrorWrapper
        error={get_reconcilers_resp}
        onReload={() => {
          this.setState({ loading: true });
          this.get_reconcilers.execute();
        }}
      >
        <ErrorWrapper
          error={detail_source_resp}
          onReload={() => {
            this.setState({ loading: true });
            this.detail_source.execute();
          }}
        >
          <Modal
            visible={this.state.view_transaction_id}
            width={"90%"}
            destroyOnClose
            footer={null}
            centered
            className="transaction-modal"
            onCancel={() => {
              this.setState({
                view_transaction_id: null,
              });
            }}
          >
            <ModalTransactionDetail
              onClose={() => {
                this.setState({
                  view_transaction_id: null,
                });
              }}
              isModal={true}
              match={{
                params: {
                  transaction_id: this.state.view_transaction_id,
                },
              }}
              transaction_id={this.state.view_transaction_id}
            />
          </Modal>
          <div>
            <BasicHeader
              maintitle="Matched Txns"
              titleType="Reconciler"
              title={get_reconcilers_data.name}
              titleStyle={{
                fontWeight: "normal",
                color: COLORS.black,
              }}
              subtitle={source_obj.group_name}
              subtitleType={"Group"}
              subtitle2={source_obj.source_name}
              subtitleType2={"Source"}
              right={[
                <Link
                  to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/unreconciled`}
                >
                  <TransparentButton
                    icon={<StorageOutlined />}
                    label="Unreconciled"
                    hint="View Unreconciled"
                  />
                </Link>,
                <Link
                  to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`}
                >
                  <TransparentButton
                    label="Pending"
                    icon={<StorageOutlined />}
                    hint="View Pending"
                  />
                </Link>,
              ]}
            />
            <div style={{ textAlign: "-webkit-center", marginTop: "60px" }}>
              <div
                type="flex"
                style={{
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  margin: 20,
                  background: "white",
                  marginBottom: 4,
                  boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: 4,
                  fontSize: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      color: "#3851A3",
                      cursor: "pointer",
                      alignSelf: "center",
                    }}
                    onClick={() =>
                      this.setState({
                        advanceFilter: !this.state.advanceFilter,
                      })
                    }
                  >
                    Show Advanced Filters
                  </div>
                  <div style={{ display: "flex",gap:10 }}>
                    <this.isEqualFunction />
                    {
                      <Popconfirm
                        disabled={this.state.data.rows.length === 0}
                        title="Are you sure you want to reconcile whole data?"
                        onConfirm={() => {
                          this.onReconcileWholeData();
                          this.list_grouped_unreconciled_data.execute();
                        }}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          style={{
                            border: "none",
                            background: "#3fbeb2",
                            color: "white",
                          }}
                          loading={loadingAll}
                          disabled={this.state.data.rows.length === 0}
                        >
                          RECONCILE WHOLE DATA
                        </Button>
                      </Popconfirm>
                    }
                     <Button
                          style={{
                            border: "none",
                            // background: "#3fbeb2",
                            color: "#3fbeb2",
                          }}
                          onClick={()=>{
                            this.downloadMatchedDataExecurot.config({
                              params:{
                                source_id:this.source_id,
                                reconciler_id:this.reconciler_id,
                                ...this.state.filter_query

                              }
                            }).execute();
                          }}
                          loading={this.downloadMatchedDataExecurot?.response()?.fetching}
                          // disabled={}
                        >
                          Download
                        </Button>
                  </div>
                </div>
                {this.state.advanceFilter && (
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ width: "50%", textAlign: "start" }}>
                      <div>
                        <div style={{ marginTop: "30px" }}>OURS </div>
                        <div
                          className="flex-container"
                          //   style={{
                          //     display: "flex",
                          //     flexDirection: "row",
                          //     flexWrap: "wrap",
                          //     paddingTop: 20,
                          //   }}
                        >
                          <div className="flex-items">
                            <Input.Search
                              placeholder="Search Query"
                              className="flex-items"
                              //   style={{
                              //     marginTop: 0,
                              //     marginBottom: 10,
                              //     marginRight: 10,
                              //     width: "100%",
                              //   }}
                              value={filter_query.our_query}
                              onChange={(e) => {
                                this.stateUpdater({
                                  stateKey: "filter_query",
                                  valueKey: "our_query",
                                  value: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <CustomDateRangePicker
                            style={{
                              width: "49%",
                              //   marginLeft: 16,
                              flex: null,
                            }}
                            startDate={
                              filter_query.our_date_from
                                ? moment(
                                    filter_query.our_date_from,
                                    defaultDateFormat
                                  )
                                : null
                            }
                            endDate={
                              filter_query.our_date_to
                                ? moment(
                                    filter_query.our_date_to,
                                    defaultDateFormat
                                  )
                                : null
                            }
                            onChange={(dates) => {
                              //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                              this.stateUpdater({
                                stateKey: "filter_query",
                                appendObj: {
                                  our_date_from:
                                    dates.startDate.format(defaultDateFormat),
                                  our_date_to:
                                    dates.endDate.format(defaultDateFormat),
                                  page: 1,
                                },
                                callback: () => {
                                  //   console.log("limlasdf");
                                  // this.props.history.push({
                                  //   search: queryString.stringify(this.state.filter_query)
                                  // })
                                  // this.list_transaction.config({
                                  //     params: {
                                  //         ...this.getParams(),
                                  //         per_page:20,
                                  //         page:1
                                  //     }
                                  // }).execute()
                                },
                              });
                            }}
                          />

                          <Select
                            allowClear
                            showSearch
                            className={
                              filter_query.our_service_id
                                ? "filter-option-selected"
                                : ""
                            }
                            style={{
                              width: "49%",
                            }}
                            placeholder="Select Service"
                            value={filter_query.our_service_id}
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(value, e) => {
                              this.stateUpdater({
                                stateKey: "filter_query",
                                valueKey: "our_service_id",
                                value: value,
                              });
                            }}
                          >
                            {this.state.our_services.map((item, index) => {
                              let source = item;

                              return (
                                <Select.Option
                                  title={source.name}
                                  value={item.id}
                                  key={item.id}
                                >
                                  {source.name}
                                </Select.Option>
                              );
                            })}
                          </Select>
                          <Select
                            allowClear
                            showSearch
                            className={
                              filter_query.our_type
                                ? "filter-option-selected"
                                : ""
                            }
                            style={{
                              //   marginTop: 0,
                              //   marginBottom: 10,
                              //   marginRight: 10,
                              width: "49%",
                            }}
                            placeholder="Transaction Type"
                            value={filter_query.our_type}
                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onChange={(value, e) => {
                              this.stateUpdater({
                                stateKey: "filter_query",
                                valueKey: "our_type",
                                value: value,
                              });
                            }}
                          >
                            <Select.Option value={"D"} key={"D"}>
                              Debit
                            </Select.Option>
                            <Select.Option value={"C"} key={"C"}>
                              Credit
                            </Select.Option>
                            <Select.Option value={"N/A"} key={"N/A"}>
                              N/A
                            </Select.Option>
                          </Select>
                          <InputNumber
                            placeholder="Amount"
                            style={{
                              //   marginTop: 0,
                              //   marginBottom: 10,
                              //   marginRight: 10,
                              width: "49%",
                            }}
                            value={filter_query.our_amount}
                            onChange={(value) => {
                              this.stateUpdater({
                                stateKey: "filter_query",
                                valueKey: "our_amount",
                                value: value,
                              });
                            }}
                          />
                          <InputNumber
                            placeholder="Offset"
                            disabled={!filter_query.our_amount}
                            style={{
                              //   marginTop: 0,
                              //   marginBottom: 10,
                              //   marginRight: 10,
                              width: "49%",
                            }}
                            value={filter_query.our_offset}
                            onChange={(value) => {
                              this.stateUpdater({
                                stateKey: "filter_query",
                                valueKey: "our_offset",
                                value: value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ width: "50%", textAlign: "start" }}>
                      <div style={{ marginTop: "30px" }}>THIERS</div>
                      <div
                        className="flex-container"
                        // style={{
                        //   display: "flex",
                        //   flexDirection: "row",
                        //   flexWrap: "wrap",
                        //   paddingTop: 20,
                        //   justifyContent: "end",
                        // }}
                      >
                        <Input.Search
                          placeholder="Search Query"
                          style={{
                            // marginTop: 0,
                            // marginBottom: 10,
                            // marginRight: 10,
                            width: "49%",
                          }}
                          value={filter_query.their_query}
                          onChange={(e) => {
                            this.stateUpdater({
                              stateKey: "filter_query",
                              valueKey: "their_query",
                              value: e.target.value,
                            });
                          }}
                        />
                        <CustomDateRangePicker
                          style={{
                            width: "49%",
                            // marginRight: 10,
                            flex: null,
                          }}
                          startDate={
                            filter_query.their_date_from
                              ? moment(
                                  filter_query.their_date_from,
                                  defaultDateFormat
                                )
                              : null
                          }
                          endDate={
                            filter_query.their_date_to
                              ? moment(
                                  filter_query.their_date_to,
                                  defaultDateFormat
                                )
                              : null
                          }
                          onChange={(dates) => {
                            //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                            this.stateUpdater({
                              stateKey: "filter_query",
                              appendObj: {
                                their_date_from:
                                  dates.startDate.format(defaultDateFormat),
                                their_date_to:
                                  dates.endDate.format(defaultDateFormat),
                                page: 1,
                              },
                              callback: () => {
                                //   console.log("limlasdf");
                                // this.props.history.push({
                                //   search: queryString.stringify(this.state.filter_query)
                                // })
                                // this.list_transaction.config({
                                //     params: {
                                //         ...this.getParams(),
                                //         per_page:20,
                                //         page:1
                                //     }
                                // }).execute()
                              },
                            });
                          }}
                        />

                        <Select
                          allowClear
                          showSearch
                          className={
                            filter_query.their_service_id
                              ? "filter-option-selected"
                              : ""
                          }
                          style={{
                            width: "49%",
                          }}
                          placeholder="Select Service"
                          value={filter_query.their_service_id}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={(value, e) => {
                            this.stateUpdater({
                              stateKey: "filter_query",
                              valueKey: "their_service_id",
                              value: value,
                            });
                          }}
                        >
                          {this.state.their_services.map((item, index) => {
                            let source = item;

                            return (
                              <Select.Option
                                title={source.name}
                                value={item.id}
                                key={item.id}
                              >
                                {source.name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                        <Select
                          allowClear
                          showSearch
                          className={
                            filter_query.their_type
                              ? "filter-option-selected"
                              : ""
                          }
                          style={{
                            // marginTop: 0,
                            // marginBottom: 10,
                            // marginRight: 10,
                            width: "49%",
                          }}
                          placeholder="Transaction Type"
                          value={filter_query.their_type}
                          // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                          onChange={(value, e) => {
                            this.stateUpdater({
                              stateKey: "filter_query",
                              valueKey: "their_type",
                              value: value,
                            });
                          }}
                        >
                          <Select.Option value={"D"} key={"D"}>
                            Debit
                          </Select.Option>
                          <Select.Option value={"C"} key={"C"}>
                            Credit
                          </Select.Option>
                          <Select.Option value={"N/A"} key={"N/A"}>
                            N/A
                          </Select.Option>
                        </Select>
                        <InputNumber
                          placeholder="Amount"
                          style={{
                            // marginTop: 0,
                            // marginBottom: 10,
                            // marginRight: 10,
                            width: "49%",
                          }}
                          value={filter_query.their_amount}
                          onChange={(value) => {
                            this.stateUpdater({
                              stateKey: "filter_query",
                              valueKey: "their_amount",
                              value: value,
                            });
                          }}
                        />
                        <InputNumber
                          placeholder="Offset"
                          disabled={!filter_query.their_amount}
                          style={{
                            // marginTop: 0,
                            // marginBottom: 10,
                            // marginRight: 10,
                            width: "49%",
                          }}
                          value={filter_query.their_offset}
                          onChange={(value) => {
                            this.stateUpdater({
                              stateKey: "filter_query",
                              valueKey: "their_offset",
                              value: value,
                            });
                          }}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          paddingTop: 8,
                          paddingBottom: 8,
                          justifyContent: "end",
                        }}
                      >
                        <CustomButton
                          className="primary-btn"
                          onClick={() => {
                            // this.setState({
                            //   selectedID: null,
                            //   pageLoading: true,
                            //   hasFilter: true,
                            // });
                            //   typeof this.props.onSelectedID === "function" &&
                            //     this.props.onSelectedID(null);

                            this.list_grouped_unreconciled_data
                              .config({
                                params: {
                                  source_id: this.source_id,
                                  reconciler_id: this.reconciler_id,
                                  ...this.state.filter_query,
                                },
                              })
                              .execute();
                          }}
                          label="FILTER"
                        />

                        <CustomButton
                          className="danger-btn"
                          onClick={() => {
                            this.setState(
                              {
                                filter_query: {
                                  source_id: this.source_id,
                                  reconciler_id: this.reconciler_id,
                                },
                                pageLoading: true,
                                selectedID: null,
                                hasFilter: false,
                              },
                              () => {
                                // this.setState({ filter_query: {} });
                                //   typeof this.props.onSelectedID ===
                                //     "function" && this.props.onSelectedID(null);
                                this.list_grouped_unreconciled_data
                                  .config({
                                    params: {
                                      ...this.state.filter_query,
                                    },
                                  })
                                  .execute();
                              }
                            );
                          }}
                          label="CLEAR ALL"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* <div style={{height:200,width:'100%',backgroundColor:'red'}}></div> */}
            <Spin spinning={loadingAll}>
              <ErrorWrapper
                error={list_grouped_unreconciled_resp}
                onReload={() => {
                  this.list_grouped_unreconciled_data.execute();
                }}
              >
                {list_grouped_unreconciled_resp.fetching ? (
                  <div
                    style={{
                      position: "fixed",
                      display: "flex",
                      height: "100vh",
                      width: "100vw",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin />
                  </div>
                ) : this.state.data.rows.length === 0 ? (
                  <div
                    style={{
                      position: "fixed",
                      display: "flex",
                      height: "100vh",
                      width: "100vw",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    {/* <div>{this.state.isEqual && <this.isEqualFunction />}</div> */}

                    <div>
                      <Empty />{" "}
                    </div>
                    <div></div>
                  </div>
                ) : (
                  <div
                    className="grouped-unreconciled-card"
                    style={{
                      marginTop: 10,
                      minWidth: 900,
                      marginBottom: 100,
                      padding: 20,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginBottom: "20px",
                      }}
                    >
                      <div></div>
                    </div>
                    {this.state.data.rows.map((item, index) => (
                      <Spin
                        spinning={
                          this.state.reconcileLoading === `loading${index}` ||
                          this.state.reconcileAllLoading === `loading${index}`
                        }
                      >
                        <GroupedUnreconciledCard
                          key={index}
                          data={item}
                          expanded_items={expanded_items}
                          expand={this.expandItems}
                          idx={index}
                          reference={reference}
                          selectedItems={this.state.selected_items}
                          onReconcile={this.onReconcile}
                          onReconcileAll={this.onReconcileAll}
                          showTransactionModal={this.showTransactionModal}
                          setSelectedItem={this.setSelectedItem}
                          spinning={
                            this.state.reconcileLoading === `loading${index}`
                          }
                          spinningAll={
                            this.state.reconcileAllLoading === `loading${index}`
                          }
                        />
                      </Spin>
                    ))}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: 20,
                      }}
                    >
                      <Pagination
                        onChange={(page, size) => {
                          this.stateUpdater({
                            stateKey: "filter_query",
                            appendObj: {
                              page: page,
                              per_page: size,
                            },
                            callback: () => {
                              this.list_grouped_unreconciled_data
                                .config({
                                  params: {
                                    source_id: this.source_id,
                                    reconciler_id: this.reconciler_id,
                                    ...this.state.filter_query,
                                  },
                                })
                                .execute();
                            },
                          });
                        }}
                        size="small"
                        showSizeChanger={true}
                        pageSizeOptions={[10, 20, 50, 100]}
                        defaultCurrent={1}
                        current={
                          rowMeta.pagination &&
                          parseInt(rowMeta.pagination.split("/")[0])
                        }
                        pageSize={(rowMeta && rowMeta.requested_count) ?? 1}
                        total={
                          rowMeta && rowMeta.total_count == 10001
                            ? 10000
                            : rowMeta.total_count
                        }
                        showTotal={(total, range) =>
                          `${formatMoney(range[0], 0)}-${formatMoney(
                            range[1],
                            0
                          )} of ${
                            rowMeta.total_count > 10000
                              ? `10,000+`
                              : formatMoney(rowMeta.total_count, 0)
                          } items`
                        }
                      />
                    </div>
                  </div>
                )}
              </ErrorWrapper>
            </Spin>
          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {}

  componentWillUnmount() {
    // if (window.slider_main) {
    //   try {
    //     window.slider_main.changeSliderState(false)
    //   } catch (e) {
    //     console.log("Failed to close slider")
    //   }
    // }
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.match.params.reconciler_id !==
      prevProps.match.params.reconciler_id
    ) {
      this.reconciler_id = this.props.match.params.reconciler_id;
      this.source_id = this.props.match.params.source_id;
      this.group_id = this.props.match.params.group_id;

      this.setState({
        loading: true,
      });
      setTimeout(() => {
        if (window.slider_main) {
          try {
            window.slider_main.changeSliderState(true);
          } catch (e) {
            console.log("Failed to close slider");
          }
        }
      }, 1000);

      this.get_reconcilers.forId(this.reconciler_id).execute();
      // this.list_reconciled_data.forId(this.reconciler_id).execute()
      // fetch the new product based and set it to the state of the component
    }
  };
}

export default withDomains(
  GroupedUnreconciledData,
  "reconciliation",
  "usergroups",
  "allData"
);
